module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_0.b180ae16.png";